import {
  getMatchStatus,
  MATCH_STATUS,
  OptaMatchStatus,
} from '@stadionhq-v3/core';
import { useEffect, useRef, useState } from 'react';
import { useIntersectionObserver } from '@stadionhq-v3/hooks';
import { MatchHeaderOnScroll } from '@components/molecules/match-header-on-scroll';
import { SfaMatchHeader as MatchHeader } from '@components/v3/organisms/sfa-match-header';
import { MatchHeaderCombinedProps } from './matchHeaderCombined.types';

const MatchHeaderCombined = ({
  matchHeaderProps,
  locale,
}: MatchHeaderCombinedProps) => {
  const fullMatchHeaderRef = useRef<HTMLDivElement>(null);
  const { isInView } = useIntersectionObserver(fullMatchHeaderRef, {
    threshold: 0.2,
  });

  const [isMatchHeaderVisible, setIsMatchHeaderVisible] =
    useState<boolean>(true);

  const [metaDescription, setMetaDescription] = useState(
    matchHeaderProps?.fixtureMetaDescription
  );

  useEffect(() => {
    const metaDescriptionElement = document.getElementsByName('description');

    setMetaDescription((metaDescriptionElement[0] as HTMLMetaElement)?.content);
  }, []);

  const isMatchLive =
    getMatchStatus(matchHeaderProps?.matchStatus as OptaMatchStatus) ===
    MATCH_STATUS.LIVE;

  useEffect(() => {
    if (fullMatchHeaderRef.current) {
      setIsMatchHeaderVisible(isInView);
    }
  }, [isInView]);

  return (
    matchHeaderProps && (
      <>
        <MatchHeader
          {...matchHeaderProps}
          ref={fullMatchHeaderRef}
          locale={locale}
          fixtureMetaDescription={
            metaDescription && matchHeaderProps?.matchStatus
              ? `${metaDescription} - ${matchHeaderProps?.matchStatus ? getMatchStatus(matchHeaderProps.matchStatus) : ''}`
              : undefined
          }
        />

        {!isMatchHeaderVisible && isMatchLive ? (
          <MatchHeaderOnScroll {...matchHeaderProps} />
        ) : null}
      </>
    )
  );
};

export default MatchHeaderCombined;
